angular.module('trainerWebApp.resources').factory('DefaultResolver',
  ['$q', 'Auth', function ($q, Auth) {

    return function () {
      var deferred = $q.defer();

      Auth.getRolePromise().then(function() {
        deferred.resolve();
      });

      return deferred.promise;
    };
  }]
);
